import {getPostIdsForRootPost} from 'features/threads/selectors/get_posts_for_root_post';
import {getPost} from 'mattermost-redux/selectors/entities/posts';
import {getChannel} from 'mattermost-redux/selectors/entities/channels';
import {getHighlightedPostId, getSelectedPostFocussedAt} from 'selectors/rhs';
import {useAppSelector} from 'stores/redux_store';

import type {Props} from './types';

export function useThreadViewerProps(props: Props) {
    const {rootPostId} = props;
    const rootPost = useAppSelector((state) => getPost(state, rootPostId));
    const highlightedPostId = useAppSelector(getHighlightedPostId);
    const selectedPostFocusedAt = useAppSelector(getSelectedPostFocussedAt);
    const postIds = useAppSelector((state) => getPostIdsForRootPost(state, rootPostId));
    const channel = useAppSelector((state) => (rootPost ? getChannel(state, rootPost.channel_id) : null));
    return {highlightedPostId, postIds, rootPost, selectedPostFocusedAt, channel};
}
